<div class="page pb-0">
  <div class="container-fluid p-0">
    <div class="breadcrumb-generic breadcrumb-generic--overlay" style="background-image: url('./assets/images/bg_contact-us.jpg');">
      <div class="container-sm">
        <h1 class="breadcrumb-generic__title">Newsletter</h1>
      </div>
    </div>
  </div>
  <div class="page-content newsletter-page">
    <div class="container">
      <div class="row newsletter-page__form">
        <div class="col">
          <div class="e-title text-center">
            <h2 class="h2">Iscriviti alla Newsletter</h2>
          </div>
          <app-element-loader
          [loadingStatus]="loadingStatus"
          [loadingMessage]="loadingMessage">
          </app-element-loader>
          <form name="geonewsForm" #geonewsForm="ngForm" (ngSubmit)="submitRequest(geonewsForm)">
            <div class="row">
              <div class="form-group col-12 col-lg-6">
                <label for="inputName">Nome</label>
                <input type="text" name="inputName" [(ngModel)]="name"
                       class="form-control" id="inputName" aria-describedby="nameHelp" placeholder="Nome...">
              </div>
              <div class="form-group col-12 col-lg-6">
                <label for="inputSurname">Cognome</label>
                <input type="text" name="inputSurname" [(ngModel)]="surname"
                       class="form-control" id="inputSurname" aria-describedby="surnameHelp" placeholder="Cognome...">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12">
                <label for="inputEmail">Indirizzo Email *</label>
                <input required type="email" name="inputEmail" [(ngModel)]="email"
                       class="form-control" id="inputEmail" aria-describedby="emailHelp" placeholder="email...">
              </div>
            </div>
            <div class="row newsletter-page__form__agency-selector" *ngIf="hasMultipleStores">
              <div class="form-group col-12">
                <div class="agency-selector-box">
                  <div class="agency-selector-box__label">Agenzia di riferimento:</div>
                  <div class="agency-selector-box__info"
                       *ngIf="selectedStore">
                    {{ selectedStore.denomination }} - {{ selectedStore.city }}{{(selectedStore.province) ? (' (' + selectedStore.province + ')') : ''}}<br>
                    (<span class="agency-selector-box__change" (click)="openStoreLocatorModal()">cambia</span>)
                  </div>
                  <button class="custom-button btn btn--blue"
                          type="button"
                          *ngIf="!selectedStore"
                          (click)="openStoreLocatorModal()">
                    Seleziona agenzia
                  </button>
                </div>
              </div>
            </div>
            <div class="row newsletter-page__form__privacy">
              <div class="col-12 text-center">
                <label>
                  Cliccando su invia esprimi il tuo consenso a ricevere newsletter e comunicazioni promozionali da parte di {{(profile$ | async)?.ragione_sociale}}.<br>
                  Leggi <a (click)="openPrivacy()">l’informativa privacy.</a>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <button [disabled]="geonewsForm.invalid || !selectedStore" type="submit" class="btn btn--blue">Invia</button>
              </div>
            </div>
          </form>
          <div class="mt-3 alert" [ngClass]="messageClass" [hidden]="!message">{{message}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
